import React from 'react';
import { Add } from 'lib/@mui/Icons';
import { Button } from 'lib/@mui';

import { EZLOGIC_BUTTON_CREATE_BACKUP } from 'constants/language_tokens';
import { useTranslate } from 'features/languages';

import styles from '../BackupsLeftPanel/BackupsLeftPanel.module.scss';

export const CreateBackupButton = ({ isCurrentControllerConnected, handleOpenCreateBackupModal }) => {
    const { t } = useTranslate();

    return (
        <div className={styles.createBackup}>
            <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleOpenCreateBackupModal}
                disabled={!isCurrentControllerConnected}
                startIcon={<Add />}
            >
                {t(EZLOGIC_BUTTON_CREATE_BACKUP)}
            </Button>
        </div>
    );
};
